import { Injectable } from '@angular/core';
import {
  AlfrescoApiService,
  AuthenticationService,
  NotificationService,
  AppConfigService,
  ContentService,
} from '@alfresco/adf-core';
import { MinimalNodeEntryEntity } from 'alfresco-js-api';
export class AosEditOnlineService {

  static ECM_HOST_CONFIG_KEY = 'ecmHost';
  static AOS_EDITONLINE_ACTION_HANDLER_KEY: string = 'aos-editonline';
  static MS_PROTOCOL_NAMES: any = {
    'doc': 'ms-word',
    'docx': 'ms-word',
    'docm': 'ms-word',
    'dot': 'ms-word',
    'dotx': 'ms-word',
    'dotm': 'ms-word',
    'xls': 'ms-excel',
    'xlsx': 'ms-excel',
    'xlsb': 'ms-excel',
    'xlsm': 'ms-excel',
    'xlt': 'ms-excel',
    'xltx': 'ms-excel',
    'xltm': 'ms-excel',
    'ppt': 'ms-powerpoint',
    'pptx': 'ms-powerpoint',
    'pot': 'ms-powerpoint',
    'potx': 'ms-powerpoint',
    'potm': 'ms-powerpoint',
    'pptm': 'ms-powerpoint',
    'pps': 'ms-powerpoint',
    'ppsx': 'ms-powerpoint',
    'ppam': 'ms-powerpoint',
    'ppsm': 'ms-powerpoint',
    'sldx': 'ms-powerpoint',
    'sldm': 'ms-powerpoint'
  };
/**
 * @param {?} alfrescoApiService
 * @param {?} alfrescoAuthenticationService
 * @param {?} appConfigService
 * @param {?} notificationService
 */
constructor(
private alfrescoApiService: AlfrescoApiService,
private alfrescoAuthenticationService: AuthenticationService,
private appConfigService: AppConfigService,
private notificationService: NotificationService,
  ) {    
  }
/**
 * @param {?} node
 * @return {?}
 */
onActionEditOnlineAos(node: MinimalNodeEntryEntity): void {    
    if (node.isFile) {
      if (node.isLocked) {
        let /** @type {?} */ checkedOut = node.aspectNames.find((aspect: string) => aspect === 'cm:checkedOut');
        let /** @type {?} */ lockOwner = node.properties['cm:lockOwner'];
        let /** @type {?} */ differentLockOwner = lockOwner.id !== this.alfrescoAuthenticationService.getEcmUsername();

        if (checkedOut && differentLockOwner) {
          this.onAlreadyLockedNotification(node.id, lockOwner);
        } else {
          this.triggerEditOnlineAos(node);
        }
      } else {
        this.triggerEditOnlineAos(node);
      }
    }        
  }
/**
 * @return {?}
 */
private getUserAgent(): string {
    return navigator.userAgent.toLowerCase();
  }
/**
 * @return {?}
 */
private isWindows(): boolean {
    return this.getUserAgent().indexOf('win') !== -1 ? true : false;
  }
/**
 * @return {?}
 */
private isMacOs(): boolean {
    return this.getUserAgent().indexOf('mac') !== -1 ? true : false;
  }
/**
 * @param {?} nodeId
 * @param {?} lockOwner
 * @return {?}
 */
private onAlreadyLockedNotification(nodeId: string, lockOwner: string) {
      this.notificationService.openSnackMessage(`Document {nodeId} locked by {lockOwner}`, 3000);
  }
/**
 * @param {?} fileExtension
 * @return {?}
 */
private getProtocolForFileExtension(fileExtension: string) {
      return AosEditOnlineService.MS_PROTOCOL_NAMES[fileExtension];
  }
/**
 * @param {?} node
 * @return {?}
 */
private triggerEditOnlineAos(node: any): void {

    let /** @type {?} */ url = this.onlineEditUrlAos(node);
    let /** @type {?} */ fileExtension = node.name.split('.').pop() !== null ? node.name.split('.').pop().toLowerCase() : '';
    let /** @type {?} */ protocolHandler = this.getProtocolForFileExtension(fileExtension);

    if (protocolHandler === undefined) {
        this.notificationService.openSnackMessage(`No protocol handler found for {fileExtension}`, 3000);
        return;
    }

    if (!this.isWindows() && !this.isMacOs()) {
        this.notificationService.openSnackMessage('Only supported for Windows and Mac', 3000);
    } else {
        this.aos_tryToLaunchOfficeByMsProtocolHandler(protocolHandler, url);
    }
  }
/**
 * @param {?} node
 * @return {?}
 */
private onlineEditUrlAos(node: any): string {

    let /** @type {?} */ pathElements = node.path.elements.slice(1, node.path.elements.length);
    let /** @type {?} */ path = '/';
    for (let /** @type {?} */ element of pathElements) {
      path = path + element.name + '/';
    }

    let /** @type {?} */ ecmHost = this.appConfigService.get<string>(AosEditOnlineService.ECM_HOST_CONFIG_KEY);
    let /** @type {?} */ url = ecmHost + '/alfresco/aos' + path + '/' + node.name;
    if (encodeURI(url).length > 256) {
      url = ecmHost + '/alfresco/aos/' + '_aos_nodeid' + '/' + node.id + '/' + node.name;
    }
    return url;
  }
/**
 * @param {?} protocolHandler
 * @param {?} url
 * @return {?}
 */
private aos_tryToLaunchOfficeByMsProtocolHandler(protocolHandler: string, url: string) {
    let /** @type {?} */ protocolUrl = protocolHandler + ':ofe%7Cu%7C' + url;
    let /** @type {?} */ protocolHandlerPresent = false;

    let /** @type {?} */ input = document.createElement('input');
    let /** @type {?} */ inputTop = document.body.scrollTop + 10;
    input.setAttribute('style', 'z-index: 1000; background-color: rgba(0, 0, 0, 0); border: none; outline: none; position: absolute; left: 10px; top: ' + inputTop + 'px;');
    document.getElementsByTagName('body')[0].appendChild(input);
    input.focus();
    input.onblur = function() {
      protocolHandlerPresent = true;
    };
    location.href = protocolUrl;
    let /** @type {?} */ that = this;
    setTimeout(function() {
      input.onblur = null;
      input.remove();      
    }, 500);
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AlfrescoApiService, },
{type: AuthenticationService, },
{type: AppConfigService, },
{type: NotificationService, },
];
}

function AosEditOnlineService_tsickle_Closure_declarations() {
/** @type {?} */
AosEditOnlineService.ECM_HOST_CONFIG_KEY;
/** @type {?} */
AosEditOnlineService.AOS_EDITONLINE_ACTION_HANDLER_KEY;
/** @type {?} */
AosEditOnlineService.MS_PROTOCOL_NAMES;
/** @type {?} */
AosEditOnlineService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AosEditOnlineService.ctorParameters;
/** @type {?} */
AosEditOnlineService.prototype.alfrescoApiService;
/** @type {?} */
AosEditOnlineService.prototype.alfrescoAuthenticationService;
/** @type {?} */
AosEditOnlineService.prototype.appConfigService;
/** @type {?} */
AosEditOnlineService.prototype.notificationService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
